export default "__VITE_ASSET__296e979f__"